import { ColDef } from 'ag-grid-community';

export const ProductsServicesTableColumnDef: ColDef[] = [
  { // ID
    headerName: 'ID',
    field: 'id',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    hide: true,
  },
  { // Name
    headerName: 'Name',
    field: 'name',
    resizable: true,
    width: 130,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  },
  { // UPC
    headerName: 'UPC',
    field: 'upc',
    resizable: true,
    width: 130,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  },
  { // Type
    headerName: 'Type',
    field: 'type',
    valueGetter: typeValueGetter,
    resizable: true,
    width: 110,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  },
  { // Category
    headerName: 'Category',
    field: 'category',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    hide: true,
  },
  { // Description
    headerName: 'Description',
    field: 'description',
    resizable: true,
    tooltipField: 'description',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    flex: 1,
  },
  { // Picture
    headerName: 'Picture',
    field: 'upc',
    resizable: true,
    width: 80,
    sortable: false,
    filter: false,
    floatingFilter: false,
    cellRenderer: (params: any) => {
      if (!params.data?.upc && !params.data?.name) return '';
      if (params.data?.type === 'Service') return '';
      const btn = document.createElement('button');
      btn.innerHTML = '<i class="fa-solid fa-image"></i>';
      btn.title = 'View Image';
      btn.style.cssText = 'background:none;border:none;cursor:pointer;color:#00a8ff;font-size:1rem;padding:2px 6px;';
      btn.addEventListener('click', () => {
        params.context?.ConfigComponent?.openPictureLightbox(params.data);
      });
      return btn;
    },
  },
  { // Sale Price
    headerName: 'Sale Price',
    field: 'sale_price_rate',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    valueFormatter: function(params) {
      if (params.value) {
        return '$' + parseFloat(params.value).toFixed(2);
      } else {
        return '';
      }
    }
  },
  { // Cost
    headerName: 'Cost',
    field: 'cost',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    valueFormatter: function(params) {
      if (params.value) {
        return '$' + parseFloat(params.value).toFixed(2);
      } else {
        return '';
      }
    }
  },
  { // Margin = (sale_price_rate - cost) / sale_price_rate * 100
    headerName: 'Margin',
    field: 'cost',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    valueFormatter: function(params) {
      if (params.value) {
        return (((params.data['sale_price_rate'] - params.data['cost'])/params.data['sale_price_rate'])*100).toFixed(1) +'%';
      } else {
        return '';
      }
    }
  },
  { // Sales Tax
    headerName: 'Sales Tax',
    field: 'sales_tax',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  },
  { // Qty on Hand — derived from inventory_lots, not stored on the item.
    // The item's id maps into accountingService.qty_sums, which is kept fresh
    // by the inventory_lots change-stream subscriber (see AccountingService).
    headerName: 'Qty on Hand',
    field: 'qty',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    valueGetter: (params) => {
      const acct = params.context?.ConfigComponent?.accountingService;
      const id = params.data?.id;
      if (!acct || !id) return null;
      return acct.qty_sums?.[id] ?? 0;
    },
  },
  { // Reorder Point
    headerName: 'Reorder Point',
    field: 'reorder_point',
    resizable: true,
    width: 110,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    hide: true,
  },
  { // Income Account
    headerName: 'Income Account',
    field: 'income_account',
    resizable: true,
    width: 125,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    hide: true,
  },
  { // Inventory Asset Account
    headerName: 'Inventory Asset Account',
    field: 'inventory_asset_account',
    resizable: true,
    width: 125,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    hide: true,
  },
  { // Preferred Vendor
    headerName: 'Preferred Vendor',
    field: 'preferred_vendor',
    resizable: true,
    width: 125,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    hide: true,
  },
  { // Active
    headerName: 'Active',
    field: 'active',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  },
  { // Archived
    headerName: 'Archived',
    field: 'archived',
    resizable: true,
    width: 125,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    hide: true,
  },
  { // Serial Item
    headerName: 'Serial Item',
    field: 'serial_item',
    width: 100,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    hide: true,
  }
];

function typeValueGetter(params) {
  if (params.data.serial_item === true) {
    return 'Serial Item';
  } else {
    return params.data.type;
  }
}